/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clip': {
    width: 16,
    height: 16,
    viewBox: '0 0 150.43 243',
    data: '<path pid="0" d="M57.86 243C24.33 243 0 216.24 0 179.36V81C0 34.82 32.34 0 75.21 0s75.22 34.82 75.22 81v81h-23.14V81c0-33.53-21.9-57.86-52.08-57.86S23.14 47.47 23.14 81v98.36c0 20.17 10.74 40.5 34.72 40.5s34.71-20.33 34.71-40.5V92.57c0-7-1.69-23.14-17.36-23.14S57.86 85.61 57.86 92.57v81H34.71v-81c0-27.68 16.28-46.28 40.5-46.28s40.5 18.6 40.5 46.28v86.79c0 36.88-24.33 63.64-57.85 63.64z"/>'
  }
})
